export default __webpack_public_path__ + "static/media/pof-swiftCopyPaymentAdvice.42402eb7.png";